import Vue from 'vue';
import Router from 'vue-router';
import i18n from '@/i18n';
import bones from '@/bones/bones';
import bonesconfig from '@/bones/config';
import Index from '@/views/Index';
import Objects from '@/views/Objects';
// import News from '@/views/News';
import Projects from '@/views/Projects';
import Exhibits from '@/views/Exhibits';
import Contact from '@/views/Contact';
import Details from '@/views/Details';
import JustBlocks from '@/views/JustBlocks';

const { api } = bones;
const { APP_BASE_URL, LANGUAGES } = bonesconfig;

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: APP_BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: { apiPath: 'index', ignoreLanguage: true },
    },
    /*
    {
      path: '/news',
      name: 'news',
      component: News,
      meta: { apiPath: 'news', ignoreLanguage: true },
    },
    {
      path: '/news/:slug',
      name: 'news-detail',
      component: Details,
      props: route => ({ type: 'news', slug: route.params.slug }),
      meta: { ignoreLanguage: true },
    },
    */
    {
      path: '/objects',
      name: 'objects',
      component: Objects,
      meta: { apiPath: 'objects', ignoreLanguage: true },
    },
    {
      path: '/objects/:slug',
      name: 'object-detail',
      component: Details,
      props: route => ({ type: 'object', slug: route.params.slug }),
      meta: { ignoreLanguage: true },
    },
    {
      path: '/projects',
      name: 'projects',
      component: Projects,
      meta: { apiPath: 'projects', ignoreLanguage: true },
    },
    {
      path: '/projects/:slug',
      name: 'projects-detail',
      component: Details,
      props: route => ({ type: 'projects', slug: route.params.slug }),
      meta: { ignoreLanguage: true },
    },
    {
      path: '/exhibits',
      name: 'exhibits',
      component: Exhibits,
      meta: { apiPath: 'exhibits', ignoreLanguage: true },
    },
    {
      path: '/exhibits/:slug',
      name: 'exhibits-detail',
      component: Details,
      props: route => ({ type: 'exhibits', slug: route.params.slug }),
      meta: { ignoreLanguage: true },
    },
    {
      path: '/cv',
      name: 'cv',
      component: JustBlocks,
      meta: { apiPath: 'cv', ignoreLanguage: true },
    },
    {
      path: '/texts',
      name: 'texts',
      component: JustBlocks,
      meta: { apiPath: 'texts', ignoreLanguage: true },
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      meta: { apiPath: 'contact', ignoreLanguage: true },
    },
    /*
    {
      path: '/:lang/blog/:slug?',
      name: 'blog-detail',
      component: BlogDetails,
      props: route => ({ slug: route.params.slug }),
      meta: {},
    },
    */
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeResolve(async (to, from, next) => {
  const ignoreLanguage = to.meta.ignoreLanguage || false;
  const language = (to.params.lang) ? to.params.lang : to.query.lang || '';

  if (!ignoreLanguage && LANGUAGES.length > 1 && !LANGUAGES.includes(language)) {
    const detected = (navigator.languages.find((lang => LANGUAGES.includes(lang.toLowerCase()))) || '').toLowerCase();
    const final = LANGUAGES.includes(detected) ? detected : LANGUAGES[0];
    const urlQueryString = window.location.search || '';
    return next({ path: `/${final}/${urlQueryString}`, replace: true });
  }

  if (i18n.locale !== language) {
    const requestedLanguage = LANGUAGES.includes(language) ? language : LANGUAGES[0];
    // eslint-disable-next-line
    const messages = await import(/* webpackChunkName: "i18n-[request]" */ '@/locales/' + requestedLanguage);
    i18n.setLocaleMessage(requestedLanguage, messages.default);
    document.documentElement.lang = requestedLanguage;
    i18n.locale = requestedLanguage;
    Vue.nextTick(() => {
      i18n.silentTranslationWarn = false;
    });
  }

  if (bones.analytics) {
    const analyticData = (to.meta || {}).analytics || {};
    analyticData.url = to.fullPath;
    bones.analytics.trackPage(analyticData);
  }

  // const RENDERED_EVENT = new Event('bones-rendered');
  if (to.meta.apiPath) {
    bones.data = null;
    const data = await api.get(to.meta.apiPath);
    if (data) {
      bones.data = data;
      if (data.meta) {
        bones.meta.update(data.meta, to);
      }
      next();
      // document.dispatchEvent(RENDERED_EVENT);
      return null;
    }
  }

  if (to.meta.title) {
    bones.meta.update({ pageTitle: i18n.t(to.meta.title) }, to);
  }
  next();
  // document.dispatchEvent(RENDERED_EVENT);
  return null;
});

export default router;
